import is from 'ramda/src/is'
import map from 'ramda/src/map'
import has from 'ramda/src/has'
import any from 'ramda/src/any'
import addIndex from 'ramda/src/addIndex'

import React, { memo, Fragment } from 'react'

import Link from 'root/src/client/web/base/Link'
import StringWithLink from 'root/src/client/web/static/reusable/StringWithLink'

import { ternary } from 'root/src/shared/util/ramdaPlus'

const componentOrString = data => (is(Object, data) ? <StringWithLink {...data} /> : data)

export default memo(({ text = '' }) => (
	<Fragment>
		{ternary(
			is(Array, text),
			ternary(
				any(has('linkLabel'), text),
				addIndex(map)((data, i) => (
					<Fragment key={i}>
						{componentOrString(data)}&nbsp;
					</Fragment>
				), text),
				addIndex(map)((stringOrLink, i) => {
					if (is(Object, stringOrLink)) {
						return (
							<Fragment key={i}>
								<Link
									routeId={stringOrLink.routeId}
									href={stringOrLink.href}
								>
									{stringOrLink.text}
								</Link>
								{' '}
							</Fragment>
						)
					}
					return <span key={i}>{stringOrLink}{' '}</span>
				}, text),
			),
			<Fragment>
				{componentOrString(text)}
			</Fragment>,
		)}
	</Fragment>
))
